import Container from 'react-bootstrap/Container';
import { useEffect } from 'react';

export default function Contact() {
  //first thing done: update page title
  useEffect(() => {
    document.title = 'Contact Us - Vista Enhancer Browser'; 
}, []);
  return (
    <main style={{ padding: "10rem 0" }}>
    <Container>
        <h2>Contact Information</h2>
        <h3>Inquiries and Requests for Materials</h3>
        <p style={{fontSize:"18px", width:"100%"}}>
        We invite external groups to submit computational predictions of developmental enhancers, as we have resources to test a limited number of such elements in our transgenic assay. If you are interested in submitting prediction, please contact <a href="mailto:enhancer.support@gmail.com">Enhancer Support</a> for details.
        <br/><br/>
        Our most commonly used vectors are available from <a href="https://www.addgene.org/Len_Pennacchio/" target="_blank" rel="noreferrer">Addgene</a>. In addition, we make archived embryos (LacZ-stained, in PFA) and vectors available upon request. To request archived materials and for all other inquiries, please also contact <a href="mailto:enhancer.support@gmail.com">Enhancer Support</a>.
        <br/>
        <br/><br/>
        For commercial licensing of the VISTA Enhancer Browser and its associated data please contact Virginia de la Puente (vtdelapuente@lbl.gov) at the Berkeley Lab's Innovation and Partnerships Office.
        </p>
      <br/><hr/><br/>
    <h3>Funding Acknowledgment</h3>
    <p style={{fontSize:"18px", width:"100%"}}>
    This work is supported by HG003988 funded by National Human Genome Research Institute, DE028599 funded by National Institute of Dental and Craniofacial Research, and HD114353 funded by National Heart, Lung, and Blood Institute. Research was performed under Department of Energy Contract DE-AC02-05CH11231, University of California, E.O. Lawrence Berkeley National Laboratory. 
    </p>
    </Container>
    </main>
  );
}